import StringValEditor from "./StringValEditor";
import StringInput from "./StringInput";

export default {
    StringValEditor,
    StringInput,
}